<template>
  <div class="version-choose-box">
    <div class="selector__wrap">
      <div class="checkbox__wrap" v-if="multiple">
        <el-checkbox :model-value="item.checked" @change="change" class="el-checkbox--big__size" />
      </div>
      <div class="radio__wrap" v-else>
        <el-radio :model-value="item.checked" @change="change" :label="true" class="el-radio--beauty">
          <span />
        </el-radio>
      </div>
    </div>

    <div class="choose-box__content">
      <div class="choose-name">
        <el-tooltip effect="dark" placement="top" :show-after="500">
          <template #default>
            <span>
              <slot name="tooltipContent">{{ item.name }}</slot>
            </span>
            <span>
              <slot name="itemName">{{ item.name }}</slot>
            </span>
          </template>
          <template #content>
            <div class="description">
              <slot name="description">{{ item.desc }}</slot>
            </div>
          </template>
        </el-tooltip>
      </div>
      <div class="description">
        <slot name="description">{{ item.desc }}</slot>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  // 源数据
  item: {
    type: Object,
    default: () => {
      return {
        checked: false,
        name: "",
        code: "",
        desc: ""
      }
    }
  },
  multiple: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['change'])
const change = (e: Event | string | boolean) => {
  emit('change', e)
}
</script>